import React, { ReactNode, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './TabView.scss';
import Tabs from '../Tabs/Tabs';
import { noSpaces } from '../../utils/helpers';

export interface ITabViewProps {
  tabs: string[];
  panels: ReactNode[];
}

const TabView = ({ tabs, panels }: ITabViewProps) => {
  const [currentTab, setCurrentTab] = useState<string>(tabs[0]);
  return (
    <section className="tab-view">
      <Tabs
        currentTab={currentTab}
        tabs={tabs}
        onSelectTab={setCurrentTab}
        justify="center"
      />
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          role="tabpanel"
          aria-labelledby={noSpaces(currentTab).toLowerCase()}
          key={noSpaces(currentTab).toLowerCase()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {panels[tabs.indexOf(currentTab)]}
        </motion.div>
      </AnimatePresence>
    </section>
  );
};

export default TabView;
